module.exports = __webpack_public_path__ + "img/finish.7ab67500.svg";